export default function UrlFactory(
    houseService,
    $routeParams,
    $location,
    $q,
    Error,
    moment
) {
    var fn = this;

    /**
     * GET FROM ROUTE, SEARCH ->
     */

    fn.getParamsFromUrl = function () {
        // let decoded = decodeURI(encoded);

        return {
            activityName: $routeParams.activity
                ? decodeURI($routeParams.activity)
                : null,
            locationName: $routeParams.location
                ? decodeURI($routeParams.location)
                : null,
            date: $routeParams.date ? $routeParams.date : null,
            start: $routeParams.start ? $routeParams.start : "0",
            end: $routeParams.end ? $routeParams.end : "-1",
            hours: $routeParams.hours ? $routeParams.hours : null,
            weeks: $routeParams.weeks ? $routeParams.weeks : null,
        };
    };

    /**
     * refactor to HouseService / other factory ?
     */
    fn.getCollection = function (
        activityName,
        locationName,
        date,
        start,
        end,
        hours,
        weeks
    ) {
        const activity = fn
            .findActivityByName(activityName)
            .then(function (value) {
                return value;
            });

        const location = fn
            .findLocationByName(locationName)
            .then(function (value) {
                return value;
            });

        // We can just return a value without creating a promise if we don't need.
        // const date = date;
        // const start = start;
        // const end = end;
        // const hours = hours;

        return $q
            .all({
                activity: activity,
                location: location,
                date: moment(date, "DD-MM-YYYY", true).isValid()
                    ? date
                    : houseService.searchFilter.startTime,
                start: start,
                end: end,
                hours: hours,
                weeks: weeks,
            })
            .then(function (collection) {
                return collection;
            });
    };

    fn.setSearchFilterService = function (
        activity,
        location,
        date,
        start,
        end,
        hours
    ) {
        // binding truth of application for search
        houseService.searchFilter.houseCategory = activity
            ? activity
            : houseService.searchFilter.houseCategory;

        houseService.searchFilter.houseType = location
            ? location
            : houseService.searchFilter.houseType;

        houseService.searchFilter.startDate = date
            ? date
            : houseService.searchFilter.startDate;

        houseService.searchFilter.startTime = start
            ? start
            : houseService.searchFilter.startTime;

        houseService.searchFilter.endTime = end
            ? end
            : houseService.searchFilter.endTime;

        houseService.searchFilter.hours = hours
            ? hours
            : houseService.searchFilter.hours;
    };

    fn.getSearchFilterService = function () {
        // let decoded = decodeURI(encoded);

        return {
            activity: houseService.searchFilter.houseCategory,
            location: houseService.searchFilter.houseType,
            date: houseService.searchFilter.startDate,
            start: houseService.searchFilter.startTime,
            end: houseService.searchFilter.endTime,
            hours: houseService.searchFilter.hours,
            scrollToSearchResults:
                houseService.searchFilter.scrollToSearchResults,
        };
    };

    /**
     * APPLY ROUTE ->
     * VOID
     */

    fn.setRoute = function (
        activity,
        location,
        date,
        start,
        end,
        hours,
        weeks = null,
        path = null
    ) {
        /**
         * Toggle between
         * search/periods
         * search/periods/fixed
         *
         */
        const hasWeeks = !!weeks;

        /**
         * Construct the path
         */
        path = path
            ? path
            : fn.prettifyParam(
                  fn.constructPath(activity, location, hasWeeks).toLowerCase()
              );

        /**
         * add other params as query ( ?date={date}&start={start}...etc.... )
         */

        $location.path(path).search({
            date: fn.prettifyParam(date),
            start: fn.prettifyParam(start),
            end: fn.prettifyParam(end),
            hours: fn.prettifyParam(hours),
            weeks: fn.prettifyParam(weeks),
            t: moment().unix(),
        });
    };

    fn.constructPath = function (activity, location, hasWeeks) {
        const path = fn.getBaseParams(activity, location, hasWeeks);

        return path;
    };

    /**
     * Convert
     * spaces = -
     * æ = ae
     * ø = oe
     * å = aa
     */
    fn.prettifyParam = function (param) {
        return param;
    };

    fn.slugify = function (str) {
        return str.toLowerCase();
    };

    fn.getBaseParams = function (activity, location, hasWeeks) {
        const hasActivity = activity.CategoryID == 0 ? false : true;
        const hasLocation = location.ID == -1 ? false : true;

        if (!hasActivity && hasLocation) {
            return "/search/location/" + location.Name;
        }

        if (
            (!hasLocation && hasActivity) ||
            (hasLocation && activity.ParentID < 1)
        ) {
            // Go straight to calender if
            if (activity.ParentID) {
                if (window.innerWidth < 425)
                    return "/search/activity/" + activity.Name;

                // Show calender view if window size is more than 425px
                return "/search/activity/" + activity.Name + "/calendar";
            }

            if (hasLocation) {
                return (
                    "/search/activity/" + activity.Name + "/" + location.Name
                );
            }

            return "/search/activity/" + activity.Name;
        }

        if (hasActivity && hasLocation) {
            const maybeFixed = hasWeeks ? "fixed/" : "";
            return (
                "/search/periods/" +
                maybeFixed +
                activity.Name +
                "/" +
                location.Name
            );
        }

        console.warn("no url to return");
        return "/";
    };

    /**
     * refactor to HouseService / other factory ?
     */

    fn.findLocationByName = function (locationName) {
        return houseService.getLocations().then(function (locations) {
            let found = null;

            if (!locationName) {
                return locations[0]; // default : alle steder
            }

            angular.forEach(locations, function (location) {
                if (location.Name.toLowerCase() == locationName) {
                    found = location;
                }
            });

            if (!found) {
                return new Error("no-location", "Lokationen blev ikke fundet");
            }

            return found;
        });
    };

    /**
     * refactor to HouseService / other factory ?
     */
    fn.findActivityByName = function (activityName) {
        return houseService.getActivities().then(function (activities) {
            if (!activityName) {
                return activities[0]; // default : alle aktiviteter
            }

            let found = null;
            angular.forEach(activities, function (activity) {
                if (activity.Name.toLowerCase() == activityName) {
                    found = activity;
                }
            });
            if (!found) {
                return new Error("no-activity", "Aktiviteten blev ikke fundet");
            }
            return found;

            // const oActivity = (fn.params.activity); // HouseCategory
        });
    };

    return fn;
}
